import ApiModelWithAuth from "../../../models/ApiModelWithAuth";
import Formatter from "../../../models/Formatter";

export class ProxyGroupFormatter extends Formatter {
    // expires_at — «до какого числа», по смыслу дата (полночь UTC): держим строкой YYYY-MM-DD —
    // так её ждёт поле даты, и diff формы не видит изменения там, где его нет (как у прокси).
    static CustomItem(data) {
        return {
            expires_at: data.expires_at ? String(data.expires_at).slice(0, 10) : '',
        };
    }
}

// Группы прокси (authorized/admin/proxy-groups, дока — api/docs/API-FRONT-PROXIES.md §8): название и
// срок (только для информации). Прокси — не больше чем в одной группе; группы и ноды — многие ко
// многим. Удаление непустой группы — 409 с текстом (тост из handleError).
export default class ApiProxyGroup extends ApiModelWithAuth {
    pathDef = 'authorized/admin/proxy-groups';
    formatterItem = ProxyGroupFormatter.Item;

    // Фильтр групп читает сортировку как order_by / order_direction, List шлёт orderBy /
    // orderBySort — переводим, иначе направление терялось бы (так же, как у ApiProxy).
    static Index(params = {}) {
        const { orderBy, orderBySort, ...other } = params;
        return super.Index({ ...other, order_by: orderBy, order_direction: orderBySort });
    }

    // Состав группы списком (§8.6): {proxy_ids} / {node_ids} → группа с новыми счётчиками и
    // node_ids. attach прокси ПЕРЕНОСИТ его из другой группы (группа у прокси одна); detach убирает
    // только из этой группы.
    static __Members(id, action, key, ids) {
        const api = new this();
        api.__type = 'store';
        api.paths = { 'store': `authorized/admin/proxy-groups/${id}/${action}` };
        api.__params = { [key]: ids };
        return api;
    }

    static AttachProxies(id, proxyIds) {
        return this.__Members(id, 'proxies/attach', 'proxy_ids', proxyIds);
    }

    static DetachProxies(id, proxyIds) {
        return this.__Members(id, 'proxies/detach', 'proxy_ids', proxyIds);
    }

    static AttachNodes(id, nodeIds) {
        return this.__Members(id, 'nodes/attach', 'node_ids', nodeIds);
    }

    static DetachNodes(id, nodeIds) {
        return this.__Members(id, 'nodes/detach', 'node_ids', nodeIds);
    }
}
